import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
	facetSelected,
	facetToggled,
	updateDismissFiltersUrl,
} from '../../../actions/lister-actions.js';
import TRANSLATIONS from '../../../translations/translations@default.json';

const QuickSearchCarouselFacetContainer = (props) => {
	const {
		facetType = '',
		facetValueArray = [],
		title = '',
		facetNameArray = [],
	} = props;

	const {
		facets = [],
		dismissFiltersUrl,
		pageTitle,
		adobeTagging: { CategorisationTagViewModel: { MainCategory } = {} } = {},
	} = useSelector((state) => state);

	const dispatch = useDispatch();

	const facetClicked = (evt, facetValue, id) => {
		evt.preventDefault();
		evt.stopPropagation();
		dispatch(facetToggled(facetValue, true));
		const facetData = {
			facetTypeHeader: facetType,
			facetTypePosition: null,
			facetValue: facetValue,
			facetValuePosition: id,
			pageUrl: dismissFiltersUrl,
			pageTitle: pageTitle,
			storeSelectedFacets: null,
			category: MainCategory,
			exposedFacets: true,
		};
		dispatch(facetSelected(facetData));
		dispatch(updateDismissFiltersUrl(facetValue.Url));
	};

	const facetValues = facets.find(({ Id }) => Id === facetType);
	const quickSearchCarouselFacets =
		TRANSLATIONS.quickSearchCarousel.quickSearchCarouselFacets;

	// If no facetValues return disabled component
	if (!facetValues?.FacetValues) {
		return (
			<div
				className="flex flex-shrink-0"
				data-tag-quicksearchsection={title}
				data-testid="quick-search-no-facets">
				<button
					className="bg-gray-20 border-gray-20 disabled cursor-default py-2 md:py-3 px-8 border border-solid flex-shrink-0 rounded mr-1 text-body-sm md:flex-grow md:w-1/3 md:px md:flex-shrink lg:w-auto lg:flex-shrink-0 text-water font-bold"
					type="button"
					data-testid="quick-search-facet-button"
					disabled
					onClick={(evt) => facetClicked(evt)}
					data-tag-quicksearchfacet={facetNameArray[0]}>
					{facetNameArray[0]}
				</button>
			</div>
		);
	}

	const selectedFacets = facetValueArray;

	const filterFacets = selectedFacets.map((selectedFacet) => {
		const filter = facetValues.FacetValues.map((filterFacet) => {
			if (filterFacet.Name === selectedFacet) {
				return filterFacet;
			}
			return null;
		});
		const nullRemoved = filter.filter(function (el) {
			return el != null;
		});
		return nullRemoved[0];
	});

	const quickSearchFacetValues = quickSearchCarouselFacets.map(
		(qsFacetValue) => {
			return qsFacetValue.facetValues[0];
		}
	);

	const position = quickSearchFacetValues.indexOf(filterFacets[0]?.Name) + 1;

	return (
		<div
			className="flex flex-shrink-0"
			data-testid="quick-search-carousel-facets">
			{filterFacets.map((filteredFacet, i) => {
				const disabled = filteredFacet?.Name !== facetValueArray[i];
				const selected = filteredFacet?.Selected ? true : false;
				let stateClasses = '';

				if (!disabled && selected) {
					stateClasses = 'bg-blue border-cta-action';
				} else if (disabled) {
					stateClasses = 'bg-gray-20 border-gray-20 disabled cursor-default';
				} else {
					stateClasses = 'bg-transparent border-gray-50';
				}

				return (
					<button
						className={`${stateClasses} ${
							i + 1 === filterFacets.length ? 'md:mr-0' : ''
						} py-2 md:py-3 px-8 border border-solid flex-shrink-0 rounded mr-1 text-body-sm md:flex-grow md:w-1/3 md:flex-shrink md:mr-1 lg:w-auto lg:flex-shrink-0 text-water font-bold`}
						type="button"
						disabled={disabled}
						onClick={(evt) => facetClicked(evt, filteredFacet)}
						data-tag-sidebarinteractiontype="facetInteraction"
						data-tag-pagetitle={document.title}
						data-tag-value={selected ? false : facetNameArray[i]}
						data-tag-exposedfacet="exposed"
						data-tag-facetposition={position}
						data-tag-pagepath={window.location.pathname}
						data-tag-name={facetValues.Name}
						data-testid="quick-search-facet-button">
						{facetNameArray[i]}
					</button>
				);
			})}
		</div>
	);
};

export default QuickSearchCarouselFacetContainer;
